import http from "../core/api/httpClient";

import {
  ClientCaseDetail,
  ClientCaseCurrentStageDocumentsResponse,
  ClientCaseDocumentUploadResponse,
} from "../types/clientPortal.types";

export const clientService = {
  async getMyCase(): Promise<ClientCaseDetail> {
    const res = await http.get<ClientCaseDetail>(`/client/caseload`);
    return res.data;
  },

  async getCaseCurrentStageDocuments(
    caseId: string
  ): Promise<ClientCaseCurrentStageDocumentsResponse> {
    const res = await http.get<ClientCaseCurrentStageDocumentsResponse>(
      `/cases/${caseId}/documents/current-stage`
    );
    return res.data;
  },

  async uploadCaseDocument(
    caseId: string,
    documentItemId: string,
    file: File,
    uploadedBy?: string
  ): Promise<ClientCaseDocumentUploadResponse> {

    const form = new FormData();
    form.append("file", file);
    if (uploadedBy) {
      form.append("uploaded_by", uploadedBy);
    }
    const res = await http.post<ClientCaseDocumentUploadResponse>(
      `/cases/${caseId}/documents/${documentItemId}/upload`,
      form
    );
    return res.data;
  },
};
